const gameDetailsAboutTabContainerId = 'game-details-about-tab-container';
const gameDetailsAboutTabContainer = (): HTMLElement | null =>
  document.getElementById(gameDetailsAboutTabContainerId);

export default {
  gameDetailsAboutTabContainerId,
  gameDetailsAboutTabContainer
};
